import { create } from 'zustand'

/**
 * Whether a fired price alert also plays a sound (the toast always shows).
 * A per-browser preference, toggled from the Price Alerts panel footer and
 * read by the app-wide notifier at fire time. On by default.
 */
const KEY = 'edge:price-alerts:sound'

function readPersisted(): boolean {
  try {
    return localStorage.getItem(KEY) !== 'off'
  } catch {
    return true
  }
}

interface PriceAlertSoundState {
  enabled: boolean
  setEnabled: (enabled: boolean) => void
}

export const usePriceAlertSoundStore = create<PriceAlertSoundState>((set) => ({
  enabled: readPersisted(),
  setEnabled: (enabled) => {
    try {
      localStorage.setItem(KEY, enabled ? 'on' : 'off')
    } catch {
      // Private mode / blocked storage: the toggle still works for this tab.
    }
    set({ enabled })
  },
}))
